import { FILTERDEFAULTS } from 'global/components/filterchips/definitions';
import { cleanCopy } from 'global/utils';

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  data: {
    scorecards: [],
  },
  view: {
    task: {
      new: [],
      ignored: [],
      sent: [],
      list: [],
    },
    alerts: {
      new: [],
      user: [],
      all: [],
    },
    hasLoadedTheme: false,
    hasShownWelcome: false,
    dontAskTaskDelete: false,
    sendReceipt: false,

    createTaskOnScore: true,
    dontShowTaskOnScore: false,

    style: {
      palette: {
        mode: 'light',
      },
    },
    edit: {
      on: false,
    },
    lang: {
      //this acts like a filter, but we are keeping it here because we want it to persist
      id: 'en',
      avail: [
        { id: 'en', title: 'English' },
        { id: 'sp', title: 'Spanish' },
      ],
    },
  },
  filter: cleanCopy(FILTERDEFAULTS),
  auth: {
    permissions: [],
    // PFM-2720: false until getUserPermissions() resolves, so consumers can tell
    // "permissions not fetched yet" apart from "fetched, user has none". Prevents a
    // fresh-login deep-link (e.g. the create-from-template static link) from gating
    // against the empty initial array before permissions load.
    permissionsLoaded: false,
    userId: null,
    email: null,
    accessToken: null,
    refreshToken: null,
    loginFailed: null,
    loginStarted: null,
    accessTokenValidUntil: 0,
    accessTokenSetAt: 0,
    realm: null,
    accountSettings: [],
  },
  hashAuth: {
    hash: null,
    hashToken: null,
    scope: null,
    expiresAt: null,
    hasNormalAccess: false,
    status: 'idle',
    error: null,
  },
};
